import { NonNullish } from '../hooks/useSKUs'
import { sleep } from '../hooks/useAxios'

export async function callWithRetry<T>({
  fn,
  predicate,
  retries = 5,
}: {
  fn: (...args: any[]) => T
  predicate: (arg: T) => boolean | Promise<boolean>
  retries: number
}): Promise<void> {
  let currentRetry = 1
  async function retry() {
    try {
      if (!(await predicate(await fn()))) {
        throw new Error()
      }
    } catch (e) {
      currentRetry++
      if (currentRetry > retries) {
        return
      }
      await sleep(2 ** currentRetry * 1000)
      return retry()
    }
  }
  return retry()
}

export function hasNonNullProperties<T extends Record<string, unknown>>(
  obj?: T
): obj is NonNullish<T> {
  if (!obj) {
    return false
  }
  return Object.values(obj).every(Boolean)
}
